import moment from 'moment';
import * as Utils from '../';

String.prototype.toInt = function ( this: string ): number {
    return parseInt( this );
};

String.prototype.Cortar = function ( this: string, n: number ): string {
    if ( this.length < n )
        return this;
    else
        return this.substring( 0, n ) + '...';
};

String.prototype.toStr = function ( this: string ): string {
    return this ? this : '';
};

String.prototype.formatCUIT = function ( this: string ): string
{
    if ( this.length === 11 )
        return `${this.substring( 0, 2 )}-${this.substring( 2, 10 )}-${this.substring( 10 )}`;
    return this;
};

String.prototype.toCamelCase = function ( this: string ): string {
    return this.toLowerCase().replace( /[-_\s.]+(.)?/g, ( _, c ) => c ? c.toUpperCase() : '' );
};

String.prototype.toCapitalCase = function ( this: string ): string
{
    let texto = this.replace( '-', ' ' );
    let e = texto.toLowerCase().split( ' ' ).map( x =>
    {
        if ( x.startsWith( '<b>' ) ) return '<b>' + x.eliminar( '<b>' ).substring( 0, 1 ).toUpperCase() + x.eliminar( '<b>' ).substring( 1 )
        if ( x.startsWith( '<strong>' ) ) return '<strong>' + x.eliminar( '<strong>' ).substring( 0, 1 ).toUpperCase() + x.eliminar( '<strong>' ).substring( 1 )
        return x.substring( 0, 1 ).toUpperCase() + x.substring( 1 )
    }).join( ' ' );

    e = e.split( '.' ).map( x =>
    {
        return x.substring( 0, 1 ).toUpperCase() + x.substring( 1 );
    } ).join( '.' );

    return e;
};


String.prototype.fechaValida = function ( this: string ): boolean {
    return moment( this ).isValid();
};

String.prototype.horaValida = function ( this: string ): boolean {
    var formats = ["YYYY-MM-DD LT", "YYYY-MM-DD h:mm:ss A", "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm"];
    return moment( '2000-01-01 ' + this, formats, true ).isValid();
};

String.prototype.toFecha = function ( this: string ): moment.Moment {
    return moment( this );
};

String.prototype.padCeros = function ( this: string, n: number ): string {
    return this.padStart( n, '0' );
};

String.prototype.eliminar = function ( this: string, s: string ): string {

    let a = this;
    while ( a.indexOf( s ) != -1 )
    {
        a = a.replace( s, '' );
    }
    return a;
};

String.prototype.insertar = function ( this: string, n: number, s: string ): string {

    if ( this && this.length >= n )
        return this.substring( 0, n ) + s + this.substring( n, this.length );
    return this;
};

String.prototype.borraLetras = function ( this: string ): string {
    let e = "";
    for ( var i = 0; i < this.length; i++ ) {
        if ( !isNaN( parseInt( this.charAt( i ) ) ) ) {
            e += this.charAt( i );
        }
    }
    return e;
};


String.prototype.formatearCodigoArticulo = function ( this: string ): string {
    if ( !this )
        return '';
    return Utils.formatearCodigoArticulo( this );
};